export const ReleaseInfo = Object.freeze({
  releaseVersion: "2026.4.22-1444.53",
  commitId: "dd13740349d0477e961d64015daab8c7d04946c6",
  commitTime: "2026-04-22T14:44:53.000Z",
});
